(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const coarsePointer = window.matchMedia('(pointer: coarse)').matches;

  const setPetMode = (mode) => {
    const normalized = ['cat', 'dog'].includes(mode) ? mode : 'all';
    document.documentElement.dataset.pv2Pet = normalized;
    document.querySelectorAll('[data-pv2-filter]').forEach((button) => {
      const active = button.dataset.pv2Filter === normalized;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    document.querySelectorAll('[data-pv2-product]').forEach((card) => {
      const pet = card.dataset.pet;
      const hidden = normalized !== 'all' && pet !== 'both' && pet !== normalized;
      card.hidden = hidden;
      if (!hidden && !reducedMotion) {
        card.animate(
          [{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: 420, easing: 'cubic-bezier(.22,1,.36,1)' }
        );
      }
    });
    const label = document.querySelector('[data-pv2-pet-label]');
    if (label) label.textContent = normalized === 'cat' ? 'CAT MODE' : normalized === 'dog' ? 'DOG MODE' : 'ALL PETS';
  };

  const initHeader = () => {
    const wrapper = document.querySelector('[data-pv2-header]');
    const toggle = document.querySelector('[data-pv2-menu-toggle]');
    const menu = document.querySelector('.pv2-mobile-menu');
    if (wrapper) {
      const hero = document.querySelector('.pv2-hero');
      if (hero && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          wrapper.classList.toggle('is-compact', !entry.isIntersecting);
        }, { rootMargin: '-110px 0px 0px 0px', threshold: 0.01 });
        observer.observe(hero);
      }
    }
    if (toggle && menu) {
      toggle.addEventListener('click', () => {
        const open = !menu.classList.contains('is-open');
        menu.classList.toggle('is-open', open);
        menu.setAttribute('aria-hidden', String(!open));
        toggle.setAttribute('aria-expanded', String(open));
      });
      menu.addEventListener('click', (event) => {
        if (!event.target.closest('a')) return;
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');
      });
    }
  };

  const initReveal = () => {
    const items = [...document.querySelectorAll('[data-pv2-reveal]')];
    if (!items.length) return;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((item) => observer.observe(item));
  };

  const initTilt = () => {
    if (reducedMotion || coarsePointer) return;
    document.querySelectorAll('[data-pv2-tilt]').forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        card.style.setProperty('--pv2-rx', `${(-y * 1.1).toFixed(2)}deg`);
        card.style.setProperty('--pv2-ry', `${(x * 1.2).toFixed(2)}deg`);
        card.style.setProperty('--pv2-y', '-1px');
      });
      card.addEventListener('pointerleave', () => {
        card.style.removeProperty('--pv2-rx');
        card.style.removeProperty('--pv2-ry');
        card.style.removeProperty('--pv2-y');
      });
    });
  };

  const initPetFilters = () => {
    const modes = ['all', 'cat', 'dog'];
    document.querySelectorAll('[data-pv2-filter]').forEach((button) => {
      button.addEventListener('click', () => setPetMode(button.dataset.pv2Filter));
    });
    document.querySelectorAll('[data-pv2-pet-choice]').forEach((button) => {
      button.addEventListener('click', () => {
        setPetMode(button.dataset.pv2PetChoice);
        document.querySelector('#PawNoviShop')?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth' });
      });
    });
    document.querySelectorAll('[data-pv2-pet-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const current = document.documentElement.dataset.pv2Pet || 'all';
        const next = modes[(modes.indexOf(current) + 1) % modes.length];
        setPetMode(next);
        button.setAttribute('aria-pressed', String(next !== 'all'));
      });
    });
    setPetMode('all');
  };

  const initGuideCards = () => {
    document.querySelectorAll('[data-pv2-accordion]').forEach((card) => {
      const button = card.querySelector('button');
      const content = card.querySelector('.pv2-guide-card__more');
      if (!button || !content) return;
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        card.classList.toggle('is-open', open);
        if (reducedMotion) {
          content.hidden = !open;
          return;
        }
        if (open) {
          content.hidden = false;
          content.animate(
            [{ opacity: 0, transform: 'translateY(-8px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 360, easing: 'cubic-bezier(.22,1,.36,1)' }
          );
        } else {
          const animation = content.animate(
            [{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(-8px)' }],
            { duration: 180, easing: 'ease-out' }
          );
          animation.addEventListener('finish', () => { content.hidden = true; }, { once: true });
        }
      });
    });
  };

  const initSignals = () => {
    const root = document.querySelector('[data-pv2-signals]');
    if (!root) return;
    root.querySelectorAll('[data-pv2-signal-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const selected = tab.dataset.pv2SignalTab;
        root.querySelectorAll('[data-pv2-signal-tab]').forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
        root.querySelectorAll('[data-pv2-signal-panel]').forEach((panel) => {
          const active = panel.dataset.pv2SignalPanel === selected;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
          if (active && !reducedMotion) {
            panel.animate(
              [{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'translateY(0)' }],
              { duration: 480, easing: 'cubic-bezier(.22,1,.36,1)' }
            );
          }
        });
      });
    });
    root.querySelectorAll('.pv2-signal-notes').forEach((group) => {
      group.querySelectorAll('[data-pv2-signal-note]').forEach((note) => {
        note.addEventListener('click', () => group.querySelectorAll('[data-pv2-signal-note]').forEach((item) => item.classList.toggle('is-active', item === note)));
      });
    });
  };

  const initParallaxCards = () => {
    if (reducedMotion || coarsePointer) return;
    document.querySelectorAll('[data-pv2-parallax-card]').forEach((card) => {
      const image = card.querySelector('img');
      if (!image) return;
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        image.style.transform = `scale(1.025) translate(${(x * -5).toFixed(1)}px, ${(y * -4).toFixed(1)}px)`;
      });
      card.addEventListener('pointerleave', () => { image.style.transform = ''; });
    });
  };

  const initSchoolDetails = () => {
    const items = [...document.querySelectorAll('.pv2-school-card')];
    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((other) => { if (other !== item) other.open = false; });
        if (!reducedMotion) {
          item.animate(
            [{ transform: 'scale(.992)' }, { transform: 'scale(1)' }],
            { duration: 360, easing: 'cubic-bezier(.22,1,.36,1)' }
          );
        }
      });
    });
  };

  const init = () => {
    initHeader();
    initReveal();
    initTilt();
    initPetFilters();
    initGuideCards();
    initSignals();
    initParallaxCards();
    initSchoolDetails();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
